// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"94cf0b05","453":"872d1134","455":"7e6e5a3c","977":"73e10147"}[chunkId] + ".chunk.js";
};